//Generated File 
export const AUTHENTICATION_ERROR = `AUTHENTICATION_ERROR`;
export const DATABASE_SEEK = `DATABASE_SEEK`;
export const DUPLICATE_FILE_PATH = `DUPLICATE_FILE_PATH`;
export const FIELD_MUST_BE_EMPTY = `FIELD_MUST_BE_EMPTY`;
export const HO_ONLINE = `HO_ONLINE`;
export const NONE = `NONE`;
export const RECORD_NOT_FOUND = `RECORD_NOT_FOUND`;
export const RECORD_NOT_VALID = `RECORD_NOT_VALID`;
export const REQUIRED_NOT_PROVIDED = `REQUIRED_NOT_PROVIDED`;
